import { render, staticRenderFns } from "./instantwin_message_table.vue?vue&type=template&id=14b44f7e&scoped=true"
import script from "./instantwin_message_table.vue?vue&type=script&lang=ts"
export * from "./instantwin_message_table.vue?vue&type=script&lang=ts"
import style0 from "./instantwin_message_table.vue?vue&type=style&index=0&id=14b44f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b44f7e",
  null
  
)

export default component.exports